'use strict';



const KeyboardKeys={
Backspace:8,
Tab:9,
Enter:13,
Shift:16,
Ctrl:17,
Alt:18,
PauseBreak:19,
CapsLock:20,
Escape:27,
Space:32,
PageUp:33,
PageDown:34,
End:35,
Home:36,
LeftArrow:37,
UpArrow:38,
RightArrow:39,
DownArrow:40,
Insert:45,
Delete:46,
SemiColon:186,
Comma:188};



module.exports=KeyboardKeys;
export default KeyboardKeys;
//# sourceMappingURL=keyboardKeys.js.map
